import { createContext, useContext } from "react";
import type { AppStore } from "./app-store";
import type { ReactNode } from "react";

const AppStoreContext = createContext<AppStore | null>(null);

export function AppStoreProvider({
  children,
  store,
}: {
  children: ReactNode;
  store: AppStore;
}) {
  return (
    <AppStoreContext.Provider value={store}>
      {children}
    </AppStoreContext.Provider>
  );
}

export function useAppStoreApi(): AppStore {
  const store = useContext(AppStoreContext);
  if (!store)
    throw new Error("useAppStoreApi must be used within AppStoreProvider");
  return store;
}
